import { ValueObject, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class InstrumentMappingSearchCriteria extends ValueObject {
    public searchCriteria: string = "";
}
